import qs from "qs";
import { useApi } from "../Api";

interface FinanceCustomerResponseAC {
    key: string,
    value: FinanceCustomerResponse
}
interface FinanceCustomerResponse {
    sapId: string,
    name?: string,
    taxCodeOrVatNumber: string
}

export const useCBRepository = () => {
    const { GET } = useApi();

    const PATH = "/finance/cb"

    async function getCustomers(search: string): Promise<FinanceCustomerResponseAC[]> {
        let params = {
            name: search
        }
        let response: FinanceCustomerResponse[] = await GET(`${PATH}/search`, { params: params, paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }) });

        return new Promise((resolve) => {
            let responseAC : FinanceCustomerResponseAC[] = response.map((it) => {
                        return {
                            key: it.sapId,
                            value: it
                        }
                    }
            );
            resolve(responseAC);
        });
    }

    return { getCustomers };
}